import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import ParentHeader from "../ParentHeader/ParentHeader";
import EventFeed from "../../Components/EventFeed/EventFeed";
import Help from "../../Components/Help/Help";
import { serviceConsumer } from "../../network/ServiceConsumer";
import "../Dashboard/Dashboard.css";

// The Results tab: events happening today, then past results.
// Signed in, two views (Devin 2026-09-25): My Results (default) = only the
// events the viewer's dancers took part in (a teacher: their school's dancers
// too); All Results = every event with results, to look up any other event.
// An adjudicator also gets My adjudications (Devin 2026-10-28): the events
// they judged, each opening on that event's My adjudications tab.
// Signed out: All Results only. The view is kept in the URL (?view=all,
// ?view=judged).
// An organizer session is not a family: /feis/participated is parent-only and
// its 403 would trip the global interceptor's logout, so organizers get All
// Results only, like a signed-out visitor.
const loadFrom = (endpoint) => async (date) => {
  const url = `${process.env.REACT_APP_BASE_URL}/feis/${endpoint}`;
  const response = await serviceConsumer("POST", url, { date });
  return { results: response?.Feis?.results || [] };
};
const loadParticipated = loadFrom("participated");
const loadAdjudicated = loadFrom("adjudicated-events");

const VIEWS = [
  { key: "mine", label: "My Results", icon: "person" },
  { key: "judged", label: "My adjudications", icon: "grading", judgeOnly: true },
  { key: "all", label: "All Results", icon: "public" },
];

const ResultsHome = () => {
  const family = !!localStorage.getItem("accessToken") && !localStorage.getItem("organizer");
  const isAdjudicator = family && localStorage.getItem("isAdjudicator") === "true";
  const location = useLocation();
  const navigate = useNavigate();
  const asked = new URLSearchParams(location.search).get("view");
  const view = !family || asked === "all" ? "all" : asked === "judged" && isAdjudicator ? "judged" : "mine";

  useEffect(() => {
    document.title = "Feis.link - Results";
    window.scroll(0, 0);
  }, []);

  const tabs = family && (
    <div className="ce-tabs results-views" role="tablist">
      {VIEWS.filter((v) => !v.judgeOnly || isAdjudicator).map((v) => (
        <button
          key={v.key}
          type="button"
          role="tab"
          aria-selected={view === v.key}
          className={`ce-tab${view === v.key ? " active" : ""}`}
          onClick={() => navigate(v.key === "mine" ? "/results" : `/results?view=${v.key}`, { replace: true })}
        >
          <span className="msr" aria-hidden="true">{v.icon}</span>
          {v.label}
        </button>
      ))}
    </div>
  );

  return (
    <div>
      <ParentHeader />
      <div className="pd-container">
        <Container style={{ marginBottom: "8%" }}>
          {view === "mine" ? (
            <EventFeed
              key="mine"
              resultsOnly
              lead={tabs}
              loadBuckets={loadParticipated}
              emptyText="Results for the events your dancers enter will show here."
            />
          ) : view === "judged" ? (
            <EventFeed
              key="judged"
              resultsOnly
              lead={tabs}
              loadBuckets={loadAdjudicated}
              resultsTab="judged"
              emptyText="Events you adjudicate will show here once their results are published."
            />
          ) : (
            <EventFeed key="all" resultsOnly lead={tabs} />
          )}
        </Container>
        <Help />
      </div>
    </div>
  );
};

export default ResultsHome;
